import { writable } from 'svelte/store';

export interface TopIslandDraftData {
  thumbnailUrl: string;
  title: string;
  nDetails: number;
  nFiles: number;
  // Normalized progress in the range 0-1. (20% finished would be 0.2)
  normalizedProgress: number;
}

export const useScrollVersion = writable(false);

export const totalScrollable = writable(0);
export const ratioScroll = writable(0);
export const scrollPageTo = writable(0);


export const topIslandOptions = {
  allowAutoDisableScrollVersion: true
};

export const startedScrolling = writable(false);


export function useScrollVersionController(node: HTMLElement) {
  // This doesnt work , refer to +layout.svelte in routes
  let prevScrollTop = 0;

  function handleScroll() {
    startedScrolling.set(true);
    if (topIslandOptions.allowAutoDisableScrollVersion) {
      const scrolledDown = node.scrollTop > prevScrollTop;
      useScrollVersion.set(scrolledDown);
    }
    prevScrollTop = node.scrollTop;
  }

  node.addEventListener('scroll', handleScroll, { capture: true });
}
